<template>
  <div class="s-strip s-leaseitnow-compare">
    <div class="page-container">
      <Loader v-if="isLoading"></Loader>
      <Alert
        v-if="errorMsgs.length"
        type="danger"
        :messages="errorMsgs"></Alert>

      <div ref="thresholdElement" class="row gx-5 mb-120">
        <div class="col-3">
          <div class="s-leaseitnow-compare__back">
            <button
              type="button"
              class="btn btn-link btn-icon-start"
              @click="onClickBack">
              <i class="icon-arrow-long-left"></i>
              {{ dictionary.buttonBackText }}
            </button>
          </div>
        </div>
        <!-- col -->
        <div v-for="item in records" :key="item" class="col-3">
          <VehicleCompareCard :item="item" />
        </div>
      </div>

      <AccordionLarge
        :title="dictionary.techTitle"
        :is-active-prop="true"
        class="theme-grey theme-icon-cirle mb-40">
        <div class="b-tech-characteristics-table">
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techBodyTypeLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.body_type }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techDimensionsLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>
                {{ item.length.toLocaleString(lang) }}/
                {{ item.typwidth.toLocaleString(lang) }}/
                {{ item.typheight.toLocaleString(lang) }}
              </span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techDoorsLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.doors }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.retailPriceLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>
                €{{ Math.round(item.price_num).toLocaleString(lang) }}
              </span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techEttLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.ett }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.retailPriceBeforeTaxesLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>
                €{{ Math.round(item.price_excl_tax_num).toLocaleString(lang) }}
              </span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techFuelLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.fuel_type }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techEmmissionsLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.co2 }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techHorsePowerLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.typhp }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techCCLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.typcaptech }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techConsumptionLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.consumption }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techTankCapacityLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ item.tecfuelcap }}</span>
            </div>
          </div>
          <div class="row gx-5">
            <div class="col-3">
              <span>{{ dictionary.techTransmissionLabel }}:</span>
            </div>
            <div v-for="item in records" :key="item" class="col-3">
              <span>{{ getTransmissionLabel(item.transmission) }}</span>
            </div>
          </div>
        </div>
      </AccordionLarge>

      <AccordionLarge
        :title="dictionary.standardAccordionHeaderTitle"
        :is-active-prop="true"
        class="theme-grey theme-icon-cirle">
        <CompareAccordionEquipment
          v-for="(item, index) in specsGroups"
          :key="index"
          :group-id="item"
          :title="getSpecsGroupTitle(item)"
          :records="records"
          :is-active-prop="true" />
      </AccordionLarge>
    </div>

    <Transition ref="stickyElement">
      <VehiclesStickyBar :records="recordsCompare" @click-back="onClickBack" />
    </Transition>
  </div>
</template>

<script>
import * as lib from './../../lib/lib'
import constants from './../../lib/constants'
import axios from 'axios'
import CompareAccordionEquipment from './../components/leaseitnow/CompareAccordionEquipment.vue'
import VehicleCompareCard from './../components/leaseitnow/VehicleCompareCard.vue'
import AccordionLarge from './../components/BookingAccordion.vue'
import Alert from '../components/common/Alert.vue'
import Loader from '../components/common/Loader.vue'
import mixinsLeaseItNow from './../mixins/leaseitnow-mixins'
/* eslint-disable no-unused-vars */
import { uniqBy } from 'lodash'
import VehiclesStickyBar from '../components/leaseitnow/VehiclesStickyBar.vue'
import StickyOnScroll from '../../modules/StickyOnScroll'

export default {
  components: {
    Alert,
    Loader,
    AccordionLarge,
    CompareAccordionEquipment,
    VehicleCompareCard,
    VehiclesStickyBar,
  },
  mixins: [mixinsLeaseItNow],
  data() {
    return {
      lang: 'en',

      isLoading: false,
      errorMsgs: [],
      slugs: [],
      records: [],
    }
  },
  computed: {
    specsGroups() {
      /* eslint-disable no-undef */
      return _.uniqBy(
        this.records.map((x) => Object.keys(x.sorted_specs)).flat()
      )
    },
  },
  mounted() {
    const { slugs } = this.$route.params
    this.lang = lib.getLocaleFromLangAttr()

    this.slugs = slugs.split(',')
    this.getCarsForComparison()

    this.$nextTick(() => {
      this.stickyOnScroll = new StickyOnScroll(
        this.$refs.stickyElement,
        this.$refs.thresholdElement
      )
    })
  },

  methods: {
    getSpecsGroupTitle(value) {
      let res = null
      this.records.forEach((element) => {
        const entry = element.sorted_specs[value]
        if (entry) {
          res = entry[0]
        }
      })

      return res
    },

    getTransmissionLabel(value) {
      let res
      const { manual, auto } = constants.leaseitnow.filters.transmissionsOptions

      switch (value) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },
    getCarsForComparison() {
      this.isLoading = true

      const { endpointGetCar } = this.configuration
      const endpoints = this.slugs.map(
        (x) => `${endpointGetCar}/${this.getTypeToken()}/${x}/`
      )
      axios
        .all(endpoints.map((endpoint) => axios.get(endpoint)))
        .then((data) => {
          this.records = data.map((x) => x.data.car)
          this.handleSuccess()
        })
        .catch((errors) => {
          this.handleError([this.dictionary.defaultErrorMessage])
          console.error(errors)
        })
    },

    onClickBack() {
      const { language } = this.$route.params
      const { sessionStorageKey } = constants.leaseitnow
      const searchargs = sessionStorage.getItem(sessionStorageKey)
      this.$router.push({
        name: 'home',
        params: { language },
        query: { searchargs: searchargs },
      })

      lib.scrollToTop()
    },

    handleSuccess() {
      this.isLoading = false
      this.errorMsgs = []
    },

    handleError(messages) {
      this.errorMsgs = messages
      this.isLoading = false
    },
  },
}
</script>
